import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { SesionAdmin, Rol } from '../types/identidad';
import { guardarSesion, obtenerSesion, limpiarSesion } from '../storage/authStorage';

interface AuthContextValue {
  sesion: SesionAdmin | null;
  login: (sesion: SesionAdmin) => void;
  logout: () => void;
  tieneRol: (...roles: Rol[]) => boolean;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: PropsWithChildren) {
  const [sesion, setSesion] = useState<SesionAdmin | null>(() => obtenerSesion());

  const login = (nuevaSesion: SesionAdmin) => {
    guardarSesion(nuevaSesion);
    setSesion(nuevaSesion);
  };

  const logout = () => {
    limpiarSesion();
    setSesion(null);
  };

  const tieneRol = (...roles: Rol[]) => Boolean(sesion && roles.includes(sesion.rol));

  return (
    <AuthContext.Provider value={{ sesion, login, logout, tieneRol }}>{children}</AuthContext.Provider>
  );
}

export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuthContext debe usarse dentro de <AuthProvider>');
  return ctx;
}
